import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
  imports: [RouterOutlet]
})
export class App {
  constructor(private title: Title, private meta: Meta) { }

  public ngOnInit(): void {
    // open graph meta tags
    this.title.setTitle("Annual Client Review 2025");

    this.meta.updateTag({ name: 'description', content: "Every year we must confirm and update all our client's profile information, beneficiaries and provide them with a new digital wallet card. This process will take under 2 minutes to complete." });
    this.meta.updateTag({ name: 'keywords', content: 'NAL Insurance, Renewal 2025' });

    // facebook
    this.meta.updateTag({ property: 'og:url', content: "https://dev--nalrenewal.nalinsurance.com/" });
    this.meta.updateTag({ property: 'og:title', content: "Annual Client Review 2025" });
    this.meta.updateTag({ property: 'og:type', content: "website" });
    this.meta.updateTag({ property: 'og:description', content: "Every year we must confirm and update all our client's profile information, beneficiaries and provide them with a new digital wallet card. This process will take under 2 minutes to complete." });
    this.meta.updateTag({ property: 'og:image', content: "assets/img/NAL-Shield-Square.jpg" });

    // twitter
    this.meta.updateTag({ property: "twitter:card", content: "summary_large_image" });
    this.meta.updateTag({ property: "twitter:url", content: "https://dev--nalrenewal.netlify.app/" });
    this.meta.updateTag({ property: "twitter:title", content: "Annual Client Review 2025" });
    this.meta.updateTag({ property: "twitter:description", content: "Every year we must confirm and update all our client's profile information, beneficiaries and provide them with a new digital wallet card. This process will take under 2 minutes to complete." });
    this.meta.updateTag({ property: "twitter:image", content: "assets/img/NAL-Shield-Square.jpg" });
  }
}
